import { render, staticRenderFns } from "./lighting.vue?vue&type=template&id=711ec9df&scoped=true&"
import script from "./lighting.vue?vue&type=script&lang=js&"
export * from "./lighting.vue?vue&type=script&lang=js&"
import style0 from "./lighting.vue?vue&type=style&index=0&id=711ec9df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711ec9df",
  null
  
)

export default component.exports